<template>
  <div>
    <div class="listNav">
      <div class="main">
        <span>您的位置：</span>
        <span>首页</span>
        <span>></span>
        <span>资源库</span>
        <span>></span>
        <span>资源库详情</span>
        <span>></span>
        <span>课程列表</span>
        <span>></span>
        <span>课程详情</span>
      </div>
    </div>
    <div class="listcenter">
      <div class="coudetails">
        <div class="coudetailscenter">
          <div>
            <el-row :gutter="20">
              <el-col :span="10">
                <div class="grid-content bg-purple">
                  <div class="imgbox">
                    <img src="../../assets/img/courseDet.png" alt />
                  </div>
                  <div class="star">
                    <i class="el-icon-star-off"></i>
                    <span>收藏</span>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple couresItem">
                  <div class="courseTit">新突破大学英语综合教程</div>
                  <div>授课人：杨云教授</div>
                  <div>所属分类：计算机</div>
                  <div>课程简介：根据我国中西部地区高职高专学校教学实际，《新突破大学英语综合教程》 由全国教指委英语组成员李力教授担任总主编，由具有丰富大学外语...</div>
                  <div class="joinBtu">
                    <router-link to="/repositories/coursedetails" tag="div">参与学习</router-link>
                    <div>
                      已有
                      <span>12</span> 人参加学习
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="detMain">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="简介" name="first">
                <div class="catalog">
                  <div class="line"></div>
                  <div class="catalogTit">简介</div>
                </div>
                <div
                  class="catalogText"
                >根据我国中西部地区高职高专学校教学实际，《新突破大学英语综合教程》由全国教指委英语组成员李力教授担任总主编，由具有丰富大学外语一线教学经验的多名教师分工编撰而成。这门课程充分体现了教育部即将出台的《大学外语教学指南》中的建设多层次多元化目标教学体系，满足学生个性化、多样性学习的要求。</div>
              </el-tab-pane>
              <el-tab-pane label="目录" name="second">
                <div class="catalog">
                  <div class="line"></div>
                  <div class="catalogTit">目录</div>
                </div>
                <div class="contents">
                  <div class="contentsTit">第一章节：英语课程大纲章节目录</div>
                  <div class="btn">开始测试</div>
                </div>
                <div class="contentsInfo">
                  <div>小节目录：仿真试题演练2</div>
                  <div>小节目录：仿真试题演练2</div>
                  <div>小节目录：仿真试题演练2</div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: 'first'
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    }
  }
}
</script>
<style lang="scss" scoped>
.listcenter {
  background: url('../../assets/img/subbg.jpg');
}
.listNav {
  width: 100%;
  height: 42px;
  background: rgba(237, 234, 231, 1);
  span {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    line-height: 42px;
    margin-right: 5px;
  }
  :nth-child(10) {
    color: #b50e05;
  }
}
.coudetails {
  width: 1112px;
  margin: 0 auto;
  height: 100%;
  background-color: #fff;
  .coudetailscenter {
    margin: 0 58px;
    padding-top: 30px;
    .imgbox {
      width: 100%;
      height: 260px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .star {
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border: 1px solid rgba(224, 224, 224, 1);
      color: rgba(102, 102, 102, 1);
      margin-top: 10px;
      span {
        margin-left: 5px;
      }
    }
  }
}
.courseTit {
  font-size: 24px;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  margin: 20px 0 47px;
}
.couresItem {
  height: 292px;
  :nth-child(2) {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    line-height: 36px;
  }
  :nth-child(3) {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    line-height: 36px;
  }
  :nth-child(4) {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    line-height: 36px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    height: 62px;
  }
}
.joinBtu {
  overflow: hidden;
  margin-top: 49px;
  div:nth-child(1) {
    width: 128px;
    height: 40px;
    background: rgba(181, 14, 5, 1);
    font-size: 14px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    line-height: 40px;
    float: left;
    margin-right: 20px;
  }
  :nth-child(2) {
    float: left;
    line-height: 40px;
    span {
      color: #b50e05;
    }
  }
}
.catalog {
  overflow: hidden;
  margin: 20px 0;
  .line {
    width: 3px;
    height: 14px;
    background: rgba(181, 14, 5, 1);
    float: left;
  }
  .catalogTit {
    font-size: 14px;
    font-weight: 500;
    color: rgba(181, 14, 5, 1);
    margin-left: 8px;
  }
}
.catalogText {
  margin-top: 20px;
  font-size: 13px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 24px;
}
.contents {
  overflow: hidden;
  .contentsTit {
    margin-bottom: 20px;
    float: left;
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
  }
  .btn {
    float: right;
    width: 82px;
    height: 30px;
    border: 1px solid rgba(224, 224, 224, 1);
    color: rgba(102, 102, 102, 1);
    background-color: none;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    &:hover {
      color: rgba(181, 14, 5, 1);
    }
  }
}
.contentsInfo {
  div {
    font-size: 13px;
    color: rgba(102, 102, 102, 1);
    line-height: 35px;
  }
}
.detMain {
  margin-top: 30px;
}
</style>